import { Map } from 'immutable';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { AuthActions } from '../../../actions/auth';
import { currentAccountIdSelector } from '../../../reducers/accounts';
import { routingSelector } from '../../../reducers/app';
import { elementTypesSelector, taskTypeIdSelector } from '../../../reducers/elementTypes';
import { currentOrganizationIdSelector } from '../../../reducers/organizations';
import { currentProjectIdSelector, projectsProjectsSelector } from '../../../reducers/projects';
import { projectsUsersSelector } from '../../../reducers/projectsUsers';
import { currentUserSelector, getUserModeByProjectId, userModeSelector, userRolesSelector } from '../../../reducers/users';
import immutableCreatorSelector from '../../../selectors/immutableCreatorSelector';
import NavBar from './NavBar';



const projectsSelector = (state, props) => {
  const currentUserProjects = projectsUsersSelector(state);
  return currentUserProjects.map((v, k) =>
    state.projects.getIn(['projects', k], Map()),
  );
  // return currentUserProjects;
};

const NavBarSelector = immutableCreatorSelector(
  [
    elementTypesSelector,
    currentUserSelector,
    routingSelector,
    currentAccountIdSelector,
    currentOrganizationIdSelector,
    userModeSelector,
    taskTypeIdSelector,
    projectsSelector,
    projectsProjectsSelector,
    currentProjectIdSelector,
    userRolesSelector,
  ],
  (
    elementTypes,
    user,
    routing,
    currentAccountId,
    currentOrganizationId,
    userMode,
    taskTypeId,
    projects,
    allProjects,
    currentProjectId,
    userRoles,
  ) => ({
    elementTypes,
    user,
    routing,
    currentAccountId,
    currentOrganizationId,
    userMode: getUserModeByProjectId(user, currentProjectId),
    taskTypeId,
    projects,
    allProjects,
    currentProjectId,
    userRoles,
  }),
);

@connect(NavBarSelector)
export default class NavBarContainer extends Component {
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(AuthActions.getMeProjects());
  }
  render() {
    return <NavBar {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/toolbars/NavBar/NavBarContainer.js